import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "11px",
	height: "11px",
	viewBox: "0 0 11 11",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Path" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Symbols",
			stroke: "none",
			strokeWidth: 1,
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Content-card-metrics-/-Standard-photo-post",
				transform: "translate(-105.000000, -1.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-4",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M115.08611,1.3245738 C115.128557,1.43776637 115.128557,1.56250467 115.08611,1.67569724 L111.666928,10.7935141 C111.569968,11.0520743 111.281762,11.1830771 111.023202,11.086117 C110.895507,11.0382314 110.792913,10.9402635 110.739191,10.8149121 L109.41122,7.71584012 L111.936812,4.18126905 L108.401471,6.70609163 L105.303169,5.37888937 C105.049354,5.27011156 104.931778,4.9761721 105.040556,4.72235721 C105.094278,4.59700576 105.196872,4.49903789 105.324566,4.45115227 L114.442383,1.03197093 C114.700944,0.935010872 114.98915,1.06601364 115.08611,1.3245738 Z",
						id: "Path"
					})
				})
			})
		})
	]
});
export default SvgSend;
